// extracted by mini-css-extract-plugin
export var blogContainer = "NewsPage-module--blogContainer--20EQV";
export var blogTitle = "NewsPage-module--blogTitle--Bu310";
export var blogContent = "NewsPage-module--blogContent--1dvCA";
export var blogImage = "NewsPage-module--blogImage--1-GwN";
export var blogDate = "NewsPage-module--blogDate--3YG-T";